var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.74335 12.8565L11.536 23.6456C12.0096 24.118 12.7769 24.118 13.2517 23.6456C13.7252 23.1732 13.7252 22.406 13.2517 21.9336L3.31503 12.0005L13.2505 2.06751C13.724 1.59513 13.724 0.827861 13.2505 0.354285C12.7769 -0.118095 12.0084 -0.118095 11.5348 0.354285L0.742154 11.1433C0.275853 11.6108 0.275854 12.3901 0.74335 12.8565Z",
    fill: "#1B1B1B",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.e097804c4e2de7c63c1caec6181680bb.svg";
export { ForwardRef as ReactComponent };